import styled from 'styled-components';

const ImageContainerStyled = styled.div.attrs({
  className: 'component__imageContainer',
})`
  width: 100%;
  height: auto;
  display: block;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    display: block;
  }

`;

export default ImageContainerStyled;
